import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { applySeo } from "@/lib/seo";

export default function CookieRichtlinien() {
  useEffect(() => {
    applySeo({
      title: "Cookie-Richtlinien – Grüne Geldanlage",
      description: "Cookie-Richtlinien: Welche Cookies wir setzen, welche Kategorien in Verwendung sind und wie Sie diese kontrollieren.",
      canonicalPath: "/cookie-richtlinien",
    });
  }, []);
  return (
    <div className="min-h-screen bg-brand-paper" data-testid="cookies-page">
      <Header />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-20 pb-24">
        <div className="overline mb-4">Rechtliches</div>
        <h1 className="font-serif text-5xl font-light leading-tight text-brand-dark mb-10">Cookie-Richtlinien</h1>
        <div className="prose-editorial max-w-none">
          <p>Diese Website nutzt ausschließlich zwingend erforderliche Cookies. Für den Betrieb nicht zwingend notwendige Cookies (Statistik, Marketing) werden derzeit nicht eingesetzt.</p>

          <h2>Kategorien</h2>
          <ul>
            <li><strong>Notwendig:</strong> Session-Cookie für den Admin-Login (Name: <code>session_token</code>, Laufzeit: 7 Tage, HttpOnly, Secure).</li>
            <li><strong>Funktional:</strong> Aktuell nicht in Verwendung.</li>
            <li><strong>Analytisch:</strong> Aktuell nicht in Verwendung.</li>
            <li><strong>Marketing:</strong> Aktuell nicht in Verwendung.</li>
          </ul>

          <h2>Cookie-Banner-Logik</h2>
          <p>Da ausschließlich technisch notwendige Cookies verwendet werden (Art. 6 Abs. 1 lit. f DSGVO / § 25 Abs. 2 TDDDG), ist ein Consent-Banner nach aktueller Rechtslage nicht zwingend erforderlich. Sobald wir optionale Cookies einführen (z. B. datenschutzfreundliche Analytics), wird ein Consent-Banner mit Ablehnungsmöglichkeit auf gleicher Ebene wie „Alle akzeptieren“ eingebunden.</p>

          <h2>Widerruf und Löschung</h2>
          <p>Sie können Cookies jederzeit in Ihrem Browser löschen und dessen Setzung durch Browser-Einstellungen unterbinden. Bitte beachten Sie, dass die Funktionalität eingeschränkt sein kann.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
